<button mat-dialog-title mat-mini-fab color="primary" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{ 'Turbo.Settings.ObjectTypeClassAttributeDialog.Headline' | translate : 'Object type class Attribute' }}">
    <form [formGroup]="form">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Turbo.Settings.ObjectTypeClassAttributeDialog.lblKey' | translate : 'Key' }}</mat-label>
        <input matInput formControlName="Key" autocomplete="off" required (blur)="onKeyBlur()">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Turbo.Settings.ObjectTypeClassAttributeDialog.lblDatatype' | translate : 'Datatype' }}</mat-label>
        <input matInput formControlName="Datatype">
      </mat-form-field>
      @if(translationKey || isAttrUpdate)
      {
      <ng-container style="margin-top: 10px;">
        <div class="row">
          <div class="col-2 d-flex align-items-center">{{ 'Turbo.Settings.ObjectTypeClassAttributeDialog.lblName' | translate : 'Name' }}</div>
          <div class="col-10">
            <t4-translation-editor [translationKey]="'T4.Data.TypeAttribute.'+ data.typeClassId + '.' + translationKey +'.Name'"></t4-translation-editor>
          </div>
        </div>
        <div class="row">
          <div class="col-2 d-flex align-items-center">{{ 'Turbo.Settings.ObjectTypeClassAttributeDialog.lblUnit' | translate : 'Unit' }}</div>
          <div class="col-10">
            <t4-translation-editor [translationKey]="'T4.Data.TypeAttribute.'+ data.typeClassId + '.' + translationKey +'.Unit'"></t4-translation-editor>
          </div>
        </div>

        <div class="row">
          <div class="col-2 d-flex align-items-center">{{ 'Turbo.Settings.ObjectTypeClassAttributeDialog.lblShorthand' | translate : 'Shorthand' }}</div>
          <div class="col-10">
            <t4-translation-editor [translationKey]="'T4.Data.TypeAttribute.'+ data.typeClassId + '.' + translationKey +'.Shorthand'"></t4-translation-editor>
          </div>
        </div>
      </ng-container>
      }
    </form>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-end">
  <div class="col-6" style="text-align: right; padding-left: 5px; padding-right: 5px;">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="save()">
      {{'Turbo.Settings.ObjectTypeClassAttributeDialog.cmdSave' | translate : 'Save' }}
    </button>
  </div>
</mat-dialog-actions>
